import "./page-flexible-components.scss";
import 'slick-carousel';
import 'slick-carousel/slick/slick.css';

jQuery(document).ready(function ($) {
    if (typeof $(document).foundation === "function") {
        $(document).foundation();
    }

    $(document).on("click", ".category-link", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var categoryId = $link.data("category-id");
        var categoryName = $link.data("category-name");
        var sectionId = $link.data("section");
        var $section = $("#" + sectionId);
        var authorId = $section.data("author-id");
        var columns = $section.data("columns");

        // Smooth scroll to section
        $("html, body").animate(
            {
                scrollTop: $section.offset().top - 100,
            },
            600
        );

        // Update title
        $("#section-title-" + sectionId).text(categoryName);

        // Hide description
        $("#section-description-" + sectionId).hide();

        // Show back button
        $("#back-button-" + sectionId).show();

        // Load posts via AJAX
        var $container = $(".cards-container-" + sectionId);
        var currentHeight = $container.outerHeight();

        $.ajax({
            url: ajaxurl || "/wp-admin/admin-ajax.php",
            type: "POST",
            data: {
                action: "load_author_category_posts",
                author_id: authorId,
                category_id: categoryId,
                columns: columns,
            },
            beforeSend: function () {
                // Set min-height to prevent layout shift
                $container.css({
                    "min-height": currentHeight + "px",
                    opacity: "0.3",
                    transition: "opacity 0.3s ease",
                });
                $container.html(
                    '<div class="text-center padding-3"><p>Loading...</p></div>'
                );
            },
            success: function (response) {
                if (response.success) {
                    $container.html(response.data.html);
                } else {
                    $container.html(
                        '<div class="text-center padding-3"><p>No posts found.</p></div>'
                    );
                }
                // Fade in new content
                setTimeout(function () {
                    $container.css("opacity", "1");
                    // Remove min-height after transition
                    setTimeout(function () {
                        $container.css("min-height", "");
                    }, 300);
                }, 50);
            },
            error: function () {
                $container.html(
                    '<div class="text-center padding-3"><p>Error loading posts.</p></div>'
                );
                $container.css("opacity", "1");
            },
        });
    });

    $(document).on("click", ".back-to-categories", function () {
        var sectionId = $(this).data("section");
        location.reload();
    });
});
